module.exports = __webpack_public_path__ + "img/panang_curry.24352be5.jpg";